export const scatterPlotStories = [
    {
        label: 'Using time scales',
        link: {
            kind: 'ScatterPlot',
            story: 'using time scales',
        },
    },
    {
        label: 'Varying symbol size',
        link: {
            kind: 'ScatterPlot',
            story: 'varying symbol size',
        },
    },
    {
        label: 'Custom tooltip',
        link: {
            kind: 'ScatterPlot',
            story: 'custom tooltip',
        },
    },
    {
        label: 'Synchronizing charts',
        link: {
            kind: 'ScatterPlot',
            story: 'synchronizing charts',
        },
    },
    {
        label: 'Using mouse enter/leave',
        link: {
            kind: 'ScatterPlot',
            story: 'using mouse enter/leave',
        },
    },
]

export const scatterPlotCanvasStories = [
    {
        label: 'Using time scales',
        link: {
            kind: 'ScatterPlot',
            story: 'using time scales',
        },
    },
    {
        label: 'Varying symbol size',
        link: {
            kind: 'ScatterPlot',
            story: 'varying symbol size',
        },
    },
    {
        label: 'Custom tooltip',
        link: {
            kind: 'ScatterPlot',
            story: 'custom tooltip',
        },
    },
]
